import BillingHTTP from 'utils/billing-http';

class RecurrentPaymentMethodService {
  update(billingId, paymentMethod) {
    return BillingHTTP.postContent(`/dashboard-api/v2/billings/${billingId}/payment-methods`, paymentMethod);
  }

  getAll(billingId) {
    return BillingHTTP.getContent(`/dashboard-api/v2/billings/${billingId}/payment-methods`);
  }

  enableBoleto(billingId) {
    return BillingHTTP.postContent(`/dashboard-api/v2/billings/${billingId}/payment-methods/boleto`);
  }

  enableCreditCard(billingId, cardId) {
    return BillingHTTP.postContent(`/dashboard-api/v2/billings/${billingId}/payment-methods/credit-card`, {
      card_id: cardId,
    });
  }

  enablePix(billingId) {
    return BillingHTTP.postContent(`/dashboard-api/v2/billings/${billingId}/payment-methods/pix`);
  }
}

export default new RecurrentPaymentMethodService();
